"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockOmniaVideoItem = exports.mockOmniaVideo = void 0;
const __1 = require("..");
const product_family_1 = require("./product_family");
function mockOmniaVideo(overrides = {}) {
    return {
        affiliate: (0, __1.mockAffiliate)(),
        brands: [],
        event_end: null,
        event_start: null,
        id: 23,
        live: false,
        livestream: false,
        mux_playback_id: 'mock_playback_id',
        omnia_video_items: [],
        publication_date: '2021-06-22',
        seasons: [],
        slug: 'mock_slug',
        source: 'http://example.com/video.mp4',
        species: [],
        summary: 'mock_summary',
        tags: [],
        thumbnail: 'http://example.com/thumb.jpg',
        title: 'mock_title',
        transcript: null,
        updated_at: '2022-08-04T16:27:13.271Z',
        user_id: 2,
        waterbodies: [],
        ...overrides,
    };
}
exports.mockOmniaVideo = mockOmniaVideo;
function mockOmniaVideoItem(overrides = {}) {
    return {
        comments: 'mock comments',
        end_sec: 10,
        id: 1,
        item_id: '1234',
        item_type: 'ProductFamily',
        item: (0, product_family_1.mockProductFamily)(),
        start_sec: 0,
        ...overrides,
    };
}
exports.mockOmniaVideoItem = mockOmniaVideoItem;
